// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// Element UI 按需引入（只注册项目实际用到的组件/服务，避免整库进包）
import Table from 'element-ui/lib/table'
import TableColumn from 'element-ui/lib/table-column'
import ElLink from 'element-ui/lib/link'
import Pagination from 'element-ui/lib/pagination'
import Form from 'element-ui/lib/form'
import FormItem from 'element-ui/lib/form-item'
import Row from 'element-ui/lib/row'
import Col from 'element-ui/lib/col'
import Tooltip from 'element-ui/lib/tooltip'
import Input from 'element-ui/lib/input'
import Upload from 'element-ui/lib/upload'
import Button from 'element-ui/lib/button'
import Timeline from 'element-ui/lib/timeline'
import TimelineItem from 'element-ui/lib/timeline-item'
import Message from 'element-ui/lib/message'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
// import axios from 'axios'
import router from './router'
import { getLan, getImg, isEn, loadLanInfo } from './i18n/i18nLan'

Vue.config.productionTip = false
// 按需注册 Element UI 组件
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(ElLink)
Vue.use(Pagination)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Row)
Vue.use(Col)
Vue.use(Tooltip)
Vue.use(Input)
Vue.use(Upload)
Vue.use(Button)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.prototype.$message = Message

/* eslint-disable no-new */
Vue.directive('click-out', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his childrens
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
});

let bus = {
  nowLan: navigator.language
};
new Vue({
  data () {
      return {
          $$state: {
              bus
          }
      }
  },
});

Vue.prototype.getLan = getLan
Vue.prototype.getImg = getImg
Vue.prototype.isEn = isEn
Vue.prototype.bus = bus;

// 先加载翻译数据（运行时按需），完成后再挂载，避免首屏缺字
function mountApp () {
  new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>',
  })
}
loadLanInfo().then(mountApp).catch(mountApp)



// WEBPACK FOOTER //
// ./src/main.js